/**
 * HoverTooltip (Epic 3 — Story 3.2/3.3)
 *
 * Lichtgewicht, toetsenbord-toegankelijke tooltip-wrapper. Dit project heeft
 * geen shadcn/ui geïnstalleerd (zie `CoreTasksTab.tsx` Dev Notes), dus geen
 * Shadcn `Tooltip` — dit volgt in plaats daarvan het bestaande
 * hover-positioned-div-patroon uit `ScoreInput.tsx` (`ScoreTooltip`),
 * gegeneraliseerd zodat 3.2 (uitzondering-chip, disabled-Opslaan-knop) en
 * 3.3 (bevroren-slotje) 'm allebei kunnen hergebruiken.
 *
 * Toont op hover ÉN focus (toetsenbord-navigeerbaar, UX-acceptatie #3.3
 * "toegankelijkheid: chips hebben tooltips").
 */
import { useRef, useState, type ReactNode } from 'react';

interface HoverTooltipProps {
  content: ReactNode;
  children: ReactNode;
  /** data-testid op de tooltip-content-div, handig voor tests. */
  testId?: string;
}

export function HoverTooltip({ content, children, testId }: HoverTooltipProps) {
  const [visible, setVisible] = useState(false);
  const wrapperRef = useRef<HTMLSpanElement>(null);

  return (
    <span
      ref={wrapperRef}
      className="relative inline-flex"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      onFocus={() => setVisible(true)}
      onBlur={() => setVisible(false)}
    >
      {children}
      {visible && (
        <div
          data-testid={testId}
          role="tooltip"
          className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-2 w-max max-w-xs px-3 py-2 text-xs bg-gray-800 text-white rounded-lg shadow-lg"
        >
          {content}
          <div className="absolute left-1/2 -translate-x-1/2 -bottom-1 w-2 h-2 bg-gray-800 rotate-45" />
        </div>
      )}
    </span>
  );
}
